import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Tab, Tabs } from '@mui/material'
import { styled } from 'theme'

export const TabContextWrap = styled(TabContext, {})
export const TabListWrap = styled(TabList, {
  button: {
    fontSize: '$16',
    fontWeight: '$semibold',
    lineHeight: '$lineHeight$24',
    textTransform: 'none',
  },
  variants: {
    color: {
      primary: {
        '.Mui-selected': {
          color: '$primaryText',
          background: '$primary50',
        },
      },
    },
  },
})

export const TabPanelWrap = styled(TabPanel, {
  padding: '0px !important',
})

export const TabsWrap = styled(Tabs, {
  '&.MuiTabs-root': {
    minHeight: '$space$44',
    width: '100%',
    mb: '$16',
  },
  'button': {
    fontSize: '$14',
    fontWeight: '$normal',
    lineHeight: '$lineHeight$20',
    textTransform: 'none',
    minWidth: 'auto',
    minHeight: 'auto',
    flexGrow: '1',
  },
  '.MuiTabs-indicator': {
    display: 'none',
  },

  'variants': {
    color: {
      transparent: {
        ".MuiTab-root[class*='transparent']": {
          padding: '$space$12 0px',
          marginRight: '$space$20',
          color: '$gray600',
        },
        '.Mui-selected': {
          color: '$primary700 !important',
        },
      },
      primary: {
        ".MuiTab-root[class*='Primary']": {
          backgroundColor: '#F4F4F5',
          padding: '$space$10 $space$14',
          marginRight: '$space$8',
          borderRadius: '$radii$sm',
          color: '$gray600',
        },
        ".Mui-selected.MuiTab-root[class*='Primary']": {
          color: '$white100',
          background: '$primary1000',
        },
      },
    },
  },
})

export const TabWrap = styled(Tab, {
  '&.MuiButtonBase-root': {
    padding: '$space$12 0px',
    marginRight: '$space$20',
    color: '$gray500',
  },

  '&.MuiButtonBase-root.Mui-disabled': {
    pointerEvents: 'auto',
    cursor: 'pointer',
  },
  '&.MuiButtonBase-root.Mui-disabled:hover': {
    'svg path': {
      stroke: '$titleGray',
    },
  },

  'variants': {
    color: {
      primary: {
        '.Mui-selected': {
          color: '$primary700 !important',
        },
      },
    },
  },
})
